import {
    usePropertyBuildRentTypeId,
    usePropertyBuildWorkDescription as usePropertyBuildWorkDescriptionTypeId,
} from '../../../../queries/usePropertyCoreFields';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';
import { DropDownBox } from '@apply/components';
import { BuildRentType, BuildWorkDescriptionType, BuildWorkDescriptionTypeOptions, BuildLoanTypeOptions } from '@apply/constants';

export interface BuildRentTypeSelectProps {
    propertyGuid: string;
    width?: string;
    required?: boolean;
    isReview?: boolean;
}

export const BuildRentTypeSelect: React.FC<BuildRentTypeSelectProps> = ({
    propertyGuid,
    required = false,
    width,
    isReview = false,
}) => {
    const workDescriptionLabel = 'Which best describes the work?';
    const buildRentTypeLabel = 'Which loan type do you want?';

    const [buildRentTypeId, set_buildRentTypeId] = usePropertyBuildRentTypeId(propertyGuid);
    const [buildWorkDescriptionTypeId, set_buildWorkDescriptionTypeId] = usePropertyBuildWorkDescriptionTypeId(propertyGuid);

    const workDescriptionList = () => {
        const empty = [{ value: undefined as BuildWorkDescriptionType | undefined, display: '' }];
        return empty.concat(BuildWorkDescriptionTypeOptions.map((o) => ({ value: o.id, display: o.display })));
    };

    const loanTypeList = () => {
        const empty = [{ value: undefined as BuildRentType | undefined, display: '' }];
        return empty.concat(BuildLoanTypeOptions.map((o) => ({ value: o.id, display: o.display })));
    };

    const handleWorkDescriptionChange = (value: BuildWorkDescriptionType | undefined) => {
        set_buildWorkDescriptionTypeId(value);
        const option = BuildWorkDescriptionTypeOptions.find((o) => o.id === value);
        if (option?.buildRentTypeId !== undefined) {
            set_buildRentTypeId(option.buildRentTypeId);
        } else {
            set_buildRentTypeId(undefined);
        }
    };

    const showLoanTypeQuestion = buildWorkDescriptionTypeId === BuildWorkDescriptionType.RenovatePlusNewSqFt;

    const workDescriptionDisplay = BuildWorkDescriptionTypeOptions.find((o) => o.id === buildWorkDescriptionTypeId)?.display;
    const loanTypeDisplay = BuildLoanTypeOptions.find((o) => o.id === buildRentTypeId)?.display;

    if (isReview) {
        return (
            <>
                <ApplicationQuestionReviewItem
                    label={workDescriptionLabel}
                    value={workDescriptionDisplay}
                />
                {showLoanTypeQuestion && (
                    <ApplicationQuestionReviewItem
                        label={buildRentTypeLabel}
                        value={loanTypeDisplay}
                    />
                )}
            </>
        );
    }

    return (
        <>
            <DropDownBox
                id='buildWorkDescriptionDropDown'
                value={buildWorkDescriptionTypeId}
                onChange={handleWorkDescriptionChange}
                required={required}
                dataSource={workDescriptionList()}
                displayExpr='display'
                valueExpr='value'
                width={width}
                label={workDescriptionLabel}
            />
            {showLoanTypeQuestion && (
                <DropDownBox
                    id='buildLoanTypeDropDown'
                    value={buildRentTypeId}
                    onChange={(value) => set_buildRentTypeId(value)}
                    required={required}
                    dataSource={loanTypeList()}
                    displayExpr='display'
                    valueExpr='value'
                    width={width}
                    label={buildRentTypeLabel}
                />
            )}
        </>
    );
};
